import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {pdfH1} from '../styles';

import {ReactComponent as EmpionLogo} from '../../../../assets/empion_logo.svg';
import {greenColors} from '../../../../layouts/theme/designSystem';

interface Props {
  sectionTitle: string;
  coverImage: string;
}

export const SectionCover = ({sectionTitle, coverImage}: Props) => {
  const {t} = useTranslation('pdfDomain');

  return (
    <Grid container p={5} justifyContent={'center'}>
      <Box
        bgcolor={greenColors[700]}
        position='absolute'
        right={65}
        p={'16px'}
        alignItems={'center'}
        display={'flex'}
        borderRadius={'8px'}
        mt={'20px'}
      >
        <EmpionLogo fill={'#fff'} height={'30px'} width={'150px'} />
      </Box>
      <Grid item>
        <CardMedia component='img' image={coverImage} sx={{height: '780px', width: '700px', borderRadius: '32px'}} />
      </Grid>
      <Grid container item mt={5} ml={4}>
        <Typography variant='h1' sx={pdfH1}>
          {t(sectionTitle)}
        </Typography>
      </Grid>
    </Grid>
  );
};
